import React from "react";
import C072FooterColumnLayout from "./C072FooterColumnLayout";
import CCOContainer from "../../fundamentals/CCOContainer";
import {SosDonationCard} from "../../../../packages/graphql-layer/src";
import {hideForBreakpoint, useBreakpoints} from "../../../utility/layoutUtils";
import dynamic from "next/dynamic";

export interface Props {
    items: Array<any>,
    CAEGlobalSettings: any,
    page?: any,
    isHideNavi?: boolean
}

const CCODonationInitializer = dynamic(() => import('../../fundamentals/CCODonationInitializer'), {ssr: false});

// Footer enthält ein ähnlichen Komponenten Switch wie PlacementItem.
// Sollte Footer ähnlich anwachsen, sollte eine dedizierte ComponentSwitch als eigene Komponente erstellt werden.
function Footer(props: Props) {
    const currentBreakpoint = useBreakpoints();

    let hasStickyDonationCard = false;
    return       <>
        {
            props.items.map((i) => {
                if (hideForBreakpoint(currentBreakpoint, i.responsiveSettings)) {
                    return null
                }
                if (i.type === "SOSDonationCard") {
                    const card = i as SosDonationCard;
                    hasStickyDonationCard = true;
                    if (i.viewtype === "modularDonationCardSticky") {
                        return (
                            <CCODonationInitializer key={card.id} item={card} />
                        );
                    }
                }
            })
        }
        <CCOContainer dataCypress='footer' id={"footer"} width={"full"} background={"grey"} border={true}
                      marginTop={hasStickyDonationCard ? 0 : 12} withMobilePadding><>

            {props.items.map((i, index) => {
                switch (i.type) {
                    case "CMCollection": {
                        switch (i.viewtype) {
                            case "c072_footer4columns": {
                                return <C072FooterColumnLayout key={index} columns={4} items={i.items}
                                                               CAEGlobalSettings={props.CAEGlobalSettings}
                                                               pageProps={props.page}/>
                            }
                            case "c072_footer3columns": {
                                return <C072FooterColumnLayout key={index} columns={3} items={i.items}
                                                               CAEGlobalSettings={props.CAEGlobalSettings}
                                                               pageProps={props.page}/>
                            }
                            default: {
                                return <React.Fragment key={index}></React.Fragment>
                            }
                        }
                    }
                }
            })
            }
        </>
        </CCOContainer>
    </>
}

export default Footer
